import { extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { IconButton, FormLabel, Spacer } from '@chakra-ui/react';
import { i18n } from '../../../../i18n/index.js';
import { withTooltip } from '../../../hoc/with-tooltip.js';
import { Icon } from '../../Icon/component.js';
import { Layout } from '../../Layout/component.js';
var infoButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(IconButton, _extends({}, rest, {
    variant: "ghost",
    color: "blue.500",
    ref: ref,
    isRound: true,
    "aria-label": i18n.t('Info'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      iconName: 'info-circle',
      prefix: 'far'
    })
  }));
});
infoButton.displayName = 'InfoButton';
var IconButtonWithTooltip = withTooltip('InfoButton')(infoButton);
var Label = function Label(_ref2) {
  var label = _ref2.label,
    id = _ref2.id,
    tooltip = _ref2.tooltip,
    asLegend = _ref2.asLegend;
  return /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FormLabel, {
    as: asLegend ? 'legend' : 'label',
    htmlFor: asLegend ? '' : id
  }, label), /*#__PURE__*/React.createElement(Spacer, null), tooltip && /*#__PURE__*/React.createElement(IconButtonWithTooltip, {
    tooltip: _objectSpread2({
      placement: 'top'
    }, tooltip)
  }));
};
Label.displayName = "Label";
export { Label };